const funnelSteps = [
  {
    type: 'landing',
    slug: '',
    showProgress: false,
  },

  {
    type: 'question',
    slug: 'question/1',
    showProgress: true,
    data: {
      id: 'what-you-sell',
      questionType: 'single',
      question: 'What does your business offer?',
      description: 'This helps us create a growth strategy for you.',
      options: ['Products', 'Services', 'Both'],
      optionImages: [
        '../../assets/images/question-answers/package.png',
        '../../assets/images/question-answers/briefcase.png',
        '../../assets/images/question-answers/money-bag.png',
      ],
      optionImagesSize: '48px',
    },
  },

  {
    type: 'promise',
    slug: 'promise',
    showProgress: true,
  },

  {
    type: 'question',
    slug: 'question/2',
    showProgress: true,
    data: {
      id: 'business-model',
      questionType: 'single',
      question: 'How do you run your business?',
      description: '',
      options: ['Online only', 'In-person only', 'Both online and in-person'],
      optionImages: [
        '../../assets/images/question-answers/laptop.png',
        '../../assets/images/question-answers/briefcase.png',
        '../../assets/images/question-answers/globe.png',
      ],
      optionImagesSize: '48px',
    },
  },

  {
    type: 'question',
    slug: 'question/3',
    showProgress: true,
    data: {
      id: 'online-presence',
      questionType: 'multi',
      question: 'Where can customers find you online?',
      description: 'Pick all that apply',
      layout: 'two-columns',
      options: [
        'Shopify', 'Instagram', 'Facebook', 'My own website',
        'Etsy', 'TikTok', 'Amazon', 'eBay',
        'Somewhere else', 'Nowhere yet',
      ],
      optionImages: [
        '../../assets/images/question-answers/shop-logos/shopify.png',
        '../../assets/images/question-answers/shop-logos/instagram.png',
        '../../assets/images/question-answers/shop-logos/facebook.png',
        '../../assets/images/question-answers/laptop.png',
        '../../assets/images/question-answers/shop-logos/etsy.png',
        '../../assets/images/question-answers/shop-logos/tiktok.png',
        '../../assets/images/question-answers/shop-logos/amazon.png',
        '../../assets/images/question-answers/shop-logos/ebay.png',
        '../../assets/images/question-answers/question-mark.png',
        '../../assets/images/question-answers/thinking-face.png',
      ],
      optionImagesSize: '32px',
    },
  },

  {
    type: 'question',
    slug: 'question/4',
    showProgress: true,
    data: {
      id: 'business-type',
      questionType: 'single',
      question: 'What type of business do you have?',
      description: '',
      options: [
        'Fashion & Clothing', 'Beauty & Skincare', 'Health & Fitness',
        'Tech & Digital', 'Art & Design', 'Jewelry & Accessories',
        'Food & Drinks', 'Something else',
      ],
      optionImages: [
        '../../assets/images/question-answers/business-categories/clothing.png',
        '../../assets/images/question-answers/business-categories/beauty.png',
        '../../assets/images/question-answers/business-categories/health.png',
        '../../assets/images/question-answers/business-categories/digital.png',
        '../../assets/images/question-answers/business-categories/creative.png',
        '../../assets/images/question-answers/business-categories/jewelry.png',
        '../../assets/images/question-answers/business-categories/food.png',
        '../../assets/images/question-answers/business-categories/other.png',
      ],
      optionImagesSize: '48px',
    },
  },

  {
    type: 'question',
    slug: 'question/5',
    showProgress: true,
    data: {
      id: 'customer-acquisition',
      questionType: 'single',
      question: 'How do you want to attract new customers?',
      description: '',
      layout: 'two-columns',
      options: [
        'Posting on social media', 'Running paid ads',
        'Both of these', 'Not sure — let AI pick for me',
      ],
      optionImages: [
        '../../assets/images/question-answers/getting-customers/social-media.png',
        '../../assets/images/question-answers/getting-customers/paid-ads.png',
        '../../assets/images/question-answers/getting-customers/both.png',
        '../../assets/images/question-answers/getting-customers/ai-can-decide.png',
      ],
      optionImagesSize: '48px',
    },
  },

  {
    type: 'question',
    slug: 'question/6',
    showProgress: true,
    data: {
      id: 'tried-social-media',
      questionType: 'single',
      question: 'Have you tried using social media to get customers?',
      description: '',
      options: ['Yes', 'No, not yet'],
      optionImages: [
        '../../assets/images/question-answers/thumbs-up.png',
        '../../assets/images/question-answers/thinking-face.png',
      ],
      optionImagesSize: '48px',
    },
  },

  {
    type: 'question',
    slug: 'question/7',
    showProgress: true,
    data: {
      id: 'social-media-goals',
      questionType: 'multi',
      question: 'What do you want to achieve on social media?',
      description: 'Pick all that apply',
      options: [
        'Grow my followers', 'Get more sales', 'Get more bookings',
        'Get more likes and comments', 'Drive traffic to my website', 'Build my brand',
      ],
      optionImages: [
        '../../assets/images/question-answers/smiling.png',
        '../../assets/images/question-answers/money-bag.png',
        '../../assets/images/question-answers/memo.png',
        '../../assets/images/question-answers/thumbs-up.png',
        '../../assets/images/question-answers/globe.png',
        '../../assets/images/question-answers/light-bulb.png',
      ],
      optionImagesSize: '32px',
    },
  },

  {
    type: 'question',
    slug: 'question/8',
    showProgress: true,
    data: {
      id: 'platform-focus',
      questionType: 'multi',
      question: 'Which platforms do you want to focus on?',
      description: 'Pick all that apply',
      layout: 'two-columns',
      options: [
        'Instagram / Facebook', 'TikTok', 'LinkedIn', 'Pinterest',
        'YouTube', 'Something else', 'Let AI pick for me',
      ],
      optionImages: [
        '../../assets/images/question-answers/shop-logos/instagram.png',
        '../../assets/images/question-answers/shop-logos/tiktok.png',
        '../../assets/images/question-answers/linkedin.png',
        '../../assets/images/question-answers/shop-logos/pinterest.png',
        '../../assets/images/question-answers/shop-logos/youtube.png',
        '../../assets/images/question-answers/question-mark.png',
        '../../assets/images/question-answers/light-bulb.png',
      ],
      optionImagesSize: '32px',
    },
  },

  {
    type: 'question',
    slug: 'question/9',
    showProgress: true,
    data: {
      id: 'social-media-time',
      questionType: 'single',
      question: 'How much time do you spend on social media daily?',
      description: '',
      image: '../../assets/images/ad1/socialmedia-scrolling.webp',
      options: ['Under 1 hour', '1–2 hours', '3–5 hours', 'More than 5 hours'],
    },
  },

  {
    type: 'question',
    slug: 'question/10',
    showProgress: true,
    data: {
      id: 'knows-what-sells',
      questionType: 'single',
      question: 'Do you know what kind of posts lead to sales?',
      description: '',
      options: ['Yes, I do', 'Somewhat', 'Not really'],
      optionImages: [
        '../../assets/images/question-answers/thumbs-up.png',
        '../../assets/images/question-answers/person-shrugging.png',
        '../../assets/images/question-answers/thumbs-down.png',
      ],
      optionImagesSize: '48px',
    },
  },

  {
    type: 'question',
    slug: 'question/11',
    showProgress: true,
    data: {
      id: 'understands-audience',
      questionType: 'single',
      question: 'Do you understand what your audience likes to see?',
      description: '',
      options: ['Yes, I do', 'Somewhat', 'Still figuring it out'],
      optionImages: [
        '../../assets/images/question-answers/thumbs-up.png',
        '../../assets/images/question-answers/person-shrugging.png',
        '../../assets/images/question-answers/thinking-face.png',
      ],
      optionImagesSize: '48px',
    },
  },

  {
    type: 'question',
    slug: 'question/12',
    showProgress: true,
    data: {
      id: 'content-preference',
      questionType: 'single',
      question: 'What kind of posts do you enjoy creating?',
      description: '',
      options: [
        'Short videos / Reels', 'Stories', 'Photos and images',
        'A little bit of everything', "I'm not sure yet",
      ],
    },
  },

  {
    type: 'question',
    slug: 'question/13',
    showProgress: true,
    data: {
      id: 'engagement-level',
      questionType: 'single',
      question: 'How much engagement do your posts usually get?',
      description: '',
      options: ['Very little', 'Some engagement', 'Lots of engagement', "I haven't posted yet"],
      optionImages: [
        '../../assets/images/question-answers/pensive.png',
        '../../assets/images/question-answers/expressionless.png',
        '../../assets/images/question-answers/smiling.png',
        '../../assets/images/question-answers/thinking-face.png',
      ],
      optionImagesSize: '48px',
    },
  },

  {
    type: 'question',
    slug: 'question/14',
    showProgress: true,
    data: {
      id: 'tried-paid-ads',
      questionType: 'single',
      question: 'Have you tried running paid ads before?',
      description: 'Many businesses see the best results with both organic posts and ads.',
      options: ['Yes', 'No'],
      optionImages: [
        '../../assets/images/question-answers/thumbs-up.png',
        '../../assets/images/question-answers/thumbs-down.png',
      ],
      optionImagesSize: '48px',
    },
  },

  {
    type: 'question',
    slug: 'question/15',
    showProgress: true,
    data: {
      id: 'ad-blockers',
      questionType: 'multi',
      question: 'What stops you from running ads?',
      description: 'Pick all that apply',
      image: '../../assets/images/ad1/concerned.webp',
      options: [
        'It costs too much', "I'm not sure they work",
        "I don't know how to set them up", "I tried but didn't get results",
        'It seems too complicated', 'Nothing — I want to try', 'None of these',
      ],
    },
  },

  {
    type: 'question',
    slug: 'question/16',
    showProgress: true,
    data: {
      id: 'video-ads-usage',
      questionType: 'multi',
      question: 'Have you used a real person speaking in your video ads?',
      description: 'Pick all that apply',
      options: [
        'I recorded myself', 'I asked friends or family to help',
        'I hired content creators', 'No, not yet',
      ],
      optionImages: [
        '../../assets/images/question-answers/smiling.png',
        '../../assets/images/question-answers/person-shrugging.png',
        '../../assets/images/question-answers/briefcase.png',
        '../../assets/images/question-answers/thinking-face.png',
      ],
      optionImagesSize: '32px',
    },
  },

  {
    type: 'question',
    slug: 'question/17',
    showProgress: true,
    data: {
      id: 'monthly-sales',
      questionType: 'single',
      question: 'How many orders do you get each month?',
      description: 'This helps AI create your personalized growth plan.',
      options: ['0–10', '10–30', '30–60', '60–90', '90+'],
    },
  },

  {
    type: 'question',
    slug: 'question/18',
    showProgress: true,
    data: {
      id: 'target-sales',
      questionType: 'single',
      question: 'How many sales do you want each month?',
      description: 'This helps AI create your promotion strategy.',
      image: '../../assets/images/ad1/strategizing.webp',
      options: ['Around 50', 'Around 150', 'Around 250', 'Around 350', '450 or more'],
    },
  },

  {
    type: 'readiness',
    slug: 'readiness',
    showProgress: false,
  },

  {
    type: 'question',
    slug: 'question/19',
    showProgress: true,
    data: {
      id: 'target-income',
      questionType: 'single',
      question: 'How much do you want to earn each month?',
      description: '',
      options: ['$1K – $5K', '$5K – $15K', '$15K+'],
      optionImages: [
        '../../assets/images/question-answers/income1.svg',
        '../../assets/images/question-answers/income3.svg',
        '../../assets/images/question-answers/income2.svg',
        '../../assets/images/question-answers/money-bag.png',
      ],
      optionImagesSize: '48px',
    },
  },

  {
    type: 'question',
    slug: 'question/20',
    showProgress: true,
    data: {
      id: 'weekly-hours',
      questionType: 'single',
      question: 'How many hours per week can you dedicate to marketing?',
      description: '',
      options: ['Under 2 hours', '2–5 hours', '5-10 hours', '10+ hours'],
    },
  },

  {
    type: 'confident',
    slug: 'confident',
    showProgress: true,
  },

  {
    type: 'calculating',
    slug: 'calculating-results',
    showProgress: false,
  },

  {
    type: 'email',
    slug: 'email',
    showProgress: false,
  },

  {
    type: 'transition',
    slug: 'transition',
    showProgress: false,
  },

  {
    type: 'checkout',
    slug: 'checkout',
    showProgress: false,
  },

  {
    type: 'special-offer',
    slug: 'special-offer',
    showProgress: false,
  },

  {
    type: 'upgrade',
    slug: 'upgrade',
    showProgress: false,
  },

  {
    type: 'success',
    slug: 'success',
    showProgress: false,
  },
];

export default funnelSteps;
